import { AuthenticationService } from '@/src/services/authentication.service';
import { MasterService } from '@/src/services/master.service';
import { CommonModule } from '@angular/common';
import { Component, input, output, signal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'components-reservation-detail',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './reservation-detail.html',
  styleUrl: './reservation-detail.css',
})
export class ReservationDetail {
  open = input<Signal<boolean>>();
  reservation = input<any>(null);
  close = output<void>();

  data = signal<any | null>(null);

  constructor(private auth: AuthenticationService, private masterService: MasterService) { }

  ngOnInit() {
    this.getDetail();
  }

  onClose() {
    this.close.emit();
  }

  getDetail() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_RESERVATION_DT: this.reservation().reservatioN_DT,
      P_RESERVATION_NO: this.reservation().reservatioN_NO
    }
    //SP_RESERVATION_DETAIL
    this.masterService.excute_sp('6a839afa-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
      if (res?.isOK) {
        this.data.set(res?.result?.dataRes[0]?.rows);
      }
    })
  }
}
